


//  AB Cable Accessories
import pABCable1 from '../assest/AB Cable/dead end.png';
import pABCable2 from '../assest/AB Cable/piercing.png';
import pABCable3 from '../assest/AB Cable/Suspension.png';

// ↑ replace with your actual filenames from the AB Cable Accessories folder

// Wire Products
import pWire1 from '../assest/wire/GI Barbed Wire.jpg';
import pWire2 from '../assest/wire/GI Stay Wire.jpg';
import pWire3 from '../assest/wire/GI Wire.jpg';

// GI Fabrication Products
import pGIClamps from '../assest/GI Products/clamps.jpg';
import pGIDTStructure from '../assest/GI Products/DT Structure (Distribution Transformer Structure).jpg';
import pGIEarthing from '../assest/GI Products/Earthing System.png';
import pGICrossSupport from '../assest/GI Products/Galvanized steel cross support.png';
import pGILineDP from '../assest/GI Products/Line DP Structure (Double Pole Structure).jpg';
import pGIStaySet from '../assest/GI Products/stay set.jpg';
import Angle from '../assest/GI Products/ANGLE.png';
import pGIVCross from '../assest/GI Products/v crosss.jpg';
import Channel from '../assest/GI Products/CHANNLE.png';
import Flat from '../assest/Hardware Fittings.png';

// Transformers
import tTransformer1 from '../assest/transformer/transformer_1.jpg';
import tTransformer2 from '../assest/transformer/transformer_2.jpg';
import tTransformer3 from '../assest/transformer/transformer_3.jpg';
import tTransformer4 from '../assest/transformer/transformer_4.webp';

// Pin Insulators
import p11kVPolymerPin from '../assest/product image transparent/11kV_Polymer_Pin_Insulator_5kN_Strength.png.png';
import p33kVPolymerPin from '../assest/product image transparent/33kV_Polymer_Pin_Insulator_10kN_Strength.png.png';
import p11kVPorcelainPinGI from '../assest/product image transparent/11kV_Porcelain_Type_Pin_Insulator_with_GI_Pin.png.png';
import p33kVPorcelainPinGI from '../assest/product image transparent/33kV_Porcelain_Pin_Insulator_with_GI_Pin.png.png';

// Tower and pole support
import pTowerSupport from '../assest/product image transparent/OCTANGLE.png';
import pPoleSupport from '../assest/product image transparent/RS NEW.png';
import pPoleSupport2 from '../assest/product image transparent/TABULAR.png';
import pPoleSupport3 from '../assest/product image transparent/PCS.png';
import pRailPole from '../assest/NEW RA.png';

//Outdoor And Indoor Cable Box (Kointing Kit And Termination Kit)
import pOutdoorCableBox from '../assest/product image transparent/Screenshot 2026-07-01 101138.png';
import pIndoorCableBox from '../assest/product image transparent/Screenshot 2026-07-01 101133.png';

//Horn Gap and Drop Out Fuses
import pHornGap from '../assest/product image transparent/Porcelain_Horn_Gap_Type_Fuse_Set.png (2).png';
import pDropOut from '../assest/product image transparent/Polymer_Horn_Gap_Type_Fuse_Set.png (2).png';
import pDropOut2 from '../assest/product image transparent/Porcelain_Drop_Out_Type_Fuse_Set.png.png';
import pDropOut3 from '../assest/product image transparent/Polymer_Horn_Gap_Type_Fuse_Set.png.png';

// Disc Insulators
import p11kVPolymericDisc from '../assest/product image transparent/11kV_Polymeric_Disc_Insulator.png.png';
import p11kVPolymerPin2 from '../assest/product image transparent/11kV_Polymer_Pin_Insulator_5kN_Strength.png (2).png';
import p11kVPorcelainDisc from '../assest/product image transparent/11kV_Porcelain_Type_Disc_Insulator.png.png';
import p33kVPorcelainDisc from '../assest/product image transparent/33kV_Porcelain_Type_Disc_Insulator.png.png';

// Air Break Switches & Isolators
import p11kVABPorcelain from '../assest/product image transparent/11kV_AB_Switch_Porcelain_Type.png.png';
import p11kVABPolymeric from '../assest/product image transparent/11kV_Air_Break_Switch_Polymeric_Type.png (2).png';
import p11kVIsolatorPorcelain from '../assest/product image transparent/11kV_Isolator_Porcelain_Type.png.png';
import p11kVIsolatorPolymer from '../assest/product image transparent/11kV_Isolator_Polymer_Type.png.png';

// Lightning Arrestor & Control Panel
import p11kVPolymericLA from '../assest/product image transparent/11kV_Polymeric_Type_Lightning_Arrester.png.png';
import p11kVPorcelainLA from '../assest/product image transparent/11kV_Porcelain_Type_Lightning_Arrester.png.png';
import p33kVPolymericLA from '../assest/product image transparent/33kV_Polymeric_Type_Lightning_Arrester.png.png';
import pControlPanel from '../assest/product image transparent/Control_Panels_and_Distribution_Panel.png.png';
import pControlPanel2 from '../assest/product image transparent/pannel 2.jpg';
import pControlPanel3 from '../assest/product image transparent/pannel 3.jpg';
import pControlPanel4 from '../assest/product image transparent/pannel 4.png';

// Conductors
import pACSR from '../assest/product image transparent/01_ACSR_Conductors.png.png';
import pAAAC from '../assest/product image transparent/02_AAAC_Conductors.png.png';
import pAAC from '../assest/product image transparent/03_AAC_Conductors.png.png';
import pACAR from '../assest/product image transparent/04_ACAR_Conductors.png.png';
import pAL59 from '../assest/product image transparent/05_AL59_Conductors.png.png';

// Cables
import pXLPE1 from '../assest/product image transparent/XLPE_Insulated_Armoured_Cable.png.png';
import pXLPE2 from '../assest/product image transparent/XLPE_Insulated_Armoured_Cable_2.png.png';
import pMVXLPE from '../assest/product image transparent/MV_XLPE_Insulated_Armoured_Cable.png.png';
import pPVC from '../assest/product image transparent/PVC_Insulated_Armoured_Cable.png.png';
import pPht from '../assest/product image transparent/HT Aerial Bunched (HT AB) Cable.jpg';
import pPlt from '../assest/product image transparent/LT Aerial Bunched (LT AB) Cable.jpg';
import control from '../assest/product image transparent/control cable.png';
import power from '../assest/product image transparent/power cable.png';

export const categories = [
  {
    title: 'Transformers',
    tag: 'DTR · 25–20000 kVA',
    type: 'manufacturing',
    items: [
      { name: 'Distribution Transformer 25 kVA', img: tTransformer1, overview: 'The 25 kVA Distribution Transformer is designed for residential, rural, and small commercial power distribution. It delivers efficient voltage conversion, reliable performance, low energy losses, and long service life with minimal maintenance.', features: [], applications: [] },
      { name: 'Distribution Transformer 20000 kVA', img: tTransformer2, overview: 'The 20000 kVA Distribution Transformer is engineered for substations, power plants, and heavy industrial applications. It provides high-capacity power distribution with excellent efficiency, dependable operation, and superior thermal performance', features: [], applications: [] },
      { name: 'Distribution Transformer 630 kVA', img: tTransformer3, overview: 'The 630 kVA Distribution Transformer is suitable for commercial buildings, industrial facilities, and utility networks. It ensures stable voltage regulation, energy-efficient operation, and reliable power supply in demanding environments.', features: [], applications: [] },
      { name: 'Distribution Transformer 1200 kVA', img: tTransformer4, overview: 'The 1200 kVA Distribution Transformer is built for large commercial, industrial, and infrastructure projects. It offers high efficiency, robust construction, excellent load handling capability, and long-lasting operational reliability.', features: [], applications: [] },
    ],
  },
  {
    title: 'Wire',
    tag: 'Wires',
    type: 'trading',
    items: [
      { name: 'GI Barbed Wire', img: pWire1, overview: "Our GI Barbed Wire is manufactured from premium-grade galvanized steel to provide superior strength, durability, and corrosion resistance. Designed for secure perimeter protection, it is widely used in agricultural fencing, industrial premises, substations, railway boundaries, government facilities, and infrastructure projects. Its sharp barbs and robust construction ensure reliable security and long-lasting performance in harsh outdoor environments.", features: [], applications: [] },
      { name: 'GI Stay Wire', img: pWire2,overview:
  "Our GI Stay Wire is manufactured using high-tensile galvanized steel to provide reliable mechanical support for electrical poles, transmission lines, and overhead distribution networks. With excellent corrosion resistance, superior tensile strength, and long service life, it is widely used in power utilities, telecommunication infrastructure, and rural electrification projects to ensure the stability and safety of utility structures.", features: [], applications: [] },
      { name: 'GI Wire', img: pWire3, overview:
  "Our Galvanized Iron (GI) Wire is manufactured from high-quality steel with a uniform zinc coating for excellent corrosion resistance, flexibility, and mechanical strength. It is extensively used in electrical transmission and distribution, earthing systems, fabrication, fencing, cable armouring, and general industrial applications. Engineered to meet industry standards, our GI wire delivers consistent performance and long-term durability in demanding environments.", features: [], applications: [] },
    ],
  },

 {
  title: 'Pin Insulators',
  tag: '11kV & 33kV',
  type: 'trading',
  items: [
    {
      name: '11 kV Polymer Pin Insulator 5 kN Strength',
      img: p11kVPolymerPin,
      overview:
        'The 11 kV Polymer Pin Insulator with 5 kN strength is designed for overhead distribution lines. Manufactured from high-quality polymer material, it offers excellent electrical insulation, UV resistance, and reliable performance in harsh environmental conditions.',
      features: [],
      applications: [],
    },
    {
      name: '33 kV Polymer Pin Insulator 10 kN Strength',
      img: p33kVPolymerPin,
      overview:
        'The 33 kV Polymer Pin Insulator with 10 kN strength is engineered for medium-voltage overhead power distribution systems. It provides superior mechanical strength, excellent weather resistance, and long-lasting insulation performance.',
      features: [],
      applications: [],
    },
    {
      name: '11 kV Porcelain Type Pin Insulator with GI Pin',
      img: p11kVPorcelainPinGI,
      overview:
        'The 11 kV Porcelain Pin Insulator with GI Pin is widely used in overhead distribution networks. Made from high-grade porcelain with a galvanized iron pin, it ensures dependable insulation, high mechanical strength, and long service life.',
      features: [],
      applications: [],
    },
    {
      name: '33 kV Porcelain Pin Insulator with GI Pin',
      img: p33kVPorcelainPinGI,
      overview:
        'The 33 kV Porcelain Pin Insulator with GI Pin is designed for medium-voltage transmission and distribution lines. It delivers excellent electrical insulation, high mechanical durability, and reliable performance under demanding operating conditions.',
      features: [],
      applications: [],
    },
  ],
},

 {
  title: 'Electrical GI Fabrication',
  tag: 'GI Fabrication',
  type: 'manufacturing',
  items: [
  
    
    {
      name: 'DT Structure (Distribution Transformer Structure)',
      img: pGIDTStructure,
      overview: 'Distribution Transformer (DT) Structures are fabricated from high-quality galvanized steel to provide stable and durable support for distribution transformers. They are designed to withstand heavy loads and harsh outdoor conditions.',
      features: [],
      applications: [],
    },
    {
      name: 'Earthing System',
      img: pGIEarthing,
      overview: 'The Earthing System is designed to safely dissipate fault currents into the ground, ensuring the protection of electrical equipment and personnel. It offers reliable conductivity, corrosion resistance, and long service life.',
      features: [],
      applications: [],
    },
    {
      name: 'Galvanized Steel Cross Support',
      img: pGICrossSupport,
      overview: 'Galvanized Steel Cross Supports are used to mount insulators and conductors on utility poles. Manufactured from premium galvanized steel, they provide excellent structural strength, durability, and resistance to corrosion.',
      features: [],
      applications: [],
    },
    {
      name: 'Line DP Structure (Double Pole Structure)',
      img: pGILineDP,
      overview: 'The Double Pole (DP) Structure is engineered to support overhead electrical lines and heavy electrical equipment. Its robust galvanized steel construction ensures stability, durability, and dependable performance in utility networks.',
      features: [],
      applications: [],
    },
    {
      name: 'Stay Set',
      img: pGIStaySet,
      overview: 'Stay Sets are designed to provide mechanical support and stability to utility poles by counteracting conductor tension. Manufactured from galvanized steel, they offer high strength, corrosion resistance, and long-lasting performance.',
      features: [],
      applications: [],
    },
    {
      name: 'V Cross',
      img: pGIVCross,
      overview: 'V Cross assemblies are fabricated for overhead power distribution systems to support insulators and conductors securely. They feature high mechanical strength, corrosion resistance, and reliable performance in outdoor environments.',
      features: [],
      applications: [],
    },
 
{
      name: 'GI Clamps',
      img: pGIClamps,
      overview: 'GI Clamps are manufactured for securely fastening conductors, insulators, and electrical hardware in overhead transmission and distribution lines. They provide excellent corrosion resistance, high mechanical strength, and reliable long-term performance.',
      features: [],
      applications: [],
    },
      {
  name: 'Transmission Line Hardware Fittings',
  img: Flat,
  overview: 'Hardware fittings are essential components used in electrical and industrial installations to provide secure connections, support, and reinforcement. They are typically manufactured from high-quality steel and offer excellent durability, dimensional accuracy, and corrosion resistance for long-lasting performance.',
  features: [],
  applications: [],
},  {
  name: 'Channel',
  img: Channel,
  overview: 'Steel channels are structural sections widely used in electrical transmission, fabrication, and construction projects. They provide excellent strength, stability, and load-bearing capacity while offering superior corrosion resistance, making them ideal for outdoor and industrial applications.',
  features: [],
  applications: [],
},
{
  name: 'Angle',
  img: Angle,
  overview: 'Steel angles are versatile structural components designed to provide strong support, reinforcement, and framing in electrical and industrial installations. Manufactured from high-quality steel, they offer excellent durability, dimensional accuracy, and corrosion resistance for long-lasting performance.',
  features: [],
  applications: [],
},

  ],
},
{
  title: 'AB Cable Accessories',
  tag: 'Accessories',
  type: 'trading',
  items: [
    {
      name: 'Dead End Clamp',
      img: pABCable1,
      overview: 'Dead End Clamps are designed to securely anchor aerial bundled (AB) cables at the end of a line or at angle points. They provide high mechanical strength, reliable cable grip, and long-lasting performance in outdoor environments.',
      features: [],
      applications: [],
    },
    {
      name: 'Piercing Connector',
      img: pABCable2,
      overview: 'Piercing Connectors are used to establish safe and reliable electrical connections without removing cable insulation. They ensure low contact resistance, easy installation, and dependable performance in overhead distribution systems.',
      features: [],
      applications: [],
    },
    {
      name: 'Suspension Clamp',
      img: pABCable3,
      overview: 'Suspension Clamps are engineered to support and suspend aerial bundled cables on utility poles while minimizing mechanical stress. They offer excellent durability, corrosion resistance, and secure cable support for long-term operation.',
      features: [],
      applications: [],
    },
  ],
},


 {
  title: 'Tower & Pole Support',
  tag: 'Structures',
  type: 'manufacturing',
  items: [
    {
      name: 'Octagonal Steel Pole',
      img: pTowerSupport,
      overview: 'Octagonal Steel Poles are manufactured for street lighting, power distribution, and utility infrastructure. Fabricated from high-quality steel with hot-dip galvanization, they provide excellent strength, corrosion resistance, and long service life.',
      features: [],
      applications: [],
    },
    {
      name: 'Rolled Steel Joist (RSJ) Pole',
      img: pPoleSupport,
      overview: 'Rolled Steel Joist (RSJ) Poles are widely used in overhead transmission and distribution networks. Their robust steel construction ensures high load-bearing capacity, structural stability, and reliable performance in outdoor installations.',
      features: [],
      applications: [],
    },
    {
      name: 'Steel Tubular Pole',
      img: pPoleSupport2,
      overview: 'Steel Tubular Poles are designed for electrical distribution lines, street lighting, and industrial applications. They offer high mechanical strength, durable galvanized protection, and dependable performance under varying environmental conditions.',
      features: [],
      applications: [],
    },
    {
      name: 'Pre-Stressed Concrete (PSC) Pole',
      img: pPoleSupport3,
      overview: 'Pre-Stressed Concrete (PSC) Poles are engineered for overhead power distribution systems. Manufactured using high-strength concrete and prestressed steel, they provide exceptional durability, load-bearing capacity, and resistance to weathering.',
      features: [],
      applications: [],
    },
    {
      name: 'Rail Pole',
      img: pRailPole,
      overview: 'Rail Poles are designed to support overhead electrical equipment and utility installations in railway infrastructure. They offer high structural strength, long-lasting durability, and reliable performance in demanding operating environments.',
      features: [],
      applications: [],
    },
  ],
},
 {
  title: 'Disc Insulators',
  tag: '11kV & 33kV',
  type: 'trading',
  items: [
    {
      name: '11 kV Polymeric Disc Insulator',
      img: p11kVPolymericDisc,
      overview: 'The 11 kV Polymeric Disc Insulator is designed for overhead power distribution systems. It offers excellent electrical insulation, high mechanical strength, and superior resistance to moisture, UV radiation, and environmental pollution for reliable long-term performance.',
      features: [],
      applications: [],
    },
    {
      name: '11 kV Polymer Pin Insulator 5 kN Strength',
      img: p11kVPolymerPin2,
      overview: 'The 11 kV Polymer Pin Insulator with 5 kN strength is manufactured for overhead distribution lines. It provides dependable insulation, lightweight construction, and excellent resistance to weathering, ensuring efficient and maintenance-free operation.',
      features: [],
      applications: [],
    },
    {
      name: '11 kV Porcelain Type Disc Insulator',
      img: p11kVPorcelainDisc,
      overview: 'The 11 kV Porcelain Type Disc Insulator is widely used in power distribution networks. Manufactured from high-grade porcelain, it delivers reliable electrical insulation, high mechanical durability, and consistent performance in outdoor conditions.',
      features: [],
      applications: [],
    },
    {
      name: '33 kV Porcelain Type Disc Insulator',
      img: p33kVPorcelainDisc,
      overview: 'The 33 kV Porcelain Type Disc Insulator is engineered for medium-voltage transmission and distribution systems. It provides excellent insulation performance, superior mechanical strength, and long service life under demanding environmental conditions.',
      features: [],
      applications: [],
    },
  ],
},
  {
  title: 'Air Break Switches',
  tag: '11kV',
  type: 'trading',
  items: [
    {
      name: '11 kV AB Switch Porcelain Type',
      img: p11kVABPorcelain,
      overview: 'The 11 kV AB Switch Porcelain Type is designed for safe switching and isolation of overhead distribution lines. Manufactured with high-quality porcelain insulators, it provides reliable electrical performance, excellent mechanical strength, and dependable operation in outdoor environments.',
      features: [],
      applications: [],
    },
    {
      name: '11 kV AB Switch Polymeric Type',
      img: p11kVABPolymeric,
      overview: 'The 11 kV AB Switch Polymeric Type is engineered for efficient switching and isolation in medium-voltage distribution systems. Its lightweight polymeric insulation offers superior resistance to moisture, UV radiation, and pollution, ensuring reliable performance with minimal maintenance.',
      features: [],
      applications: [],
    },
  ],
},
 {
  title: 'Isolators',
  tag: '11kV',
  type: 'trading',
  items: [
    {
      name: '11 kV Isolator Porcelain Type',
      img: p11kVIsolatorPorcelain,
      overview: 'The 11 kV Isolator Porcelain Type is designed to safely isolate electrical circuits during maintenance and inspection. Manufactured with high-quality porcelain insulators, it provides excellent electrical insulation, robust mechanical strength, and reliable performance in outdoor distribution networks.',
      features: [],
      applications: [],
    },
    {
      name: '11 kV Isolator Polymer Type',
      img: p11kVIsolatorPolymer,
      overview: 'The 11 kV Isolator Polymer Type is engineered for safe isolation of medium-voltage distribution lines. Its lightweight polymer insulation offers superior resistance to moisture, UV radiation, and environmental pollution, ensuring dependable operation and long service life.',
      features: [],
      applications: [],
    },
  ],
},
  {
  title: 'Lightning Arrestor',
  tag: '11kV & 33kV',
  type: 'trading',
  items: [
    {
      name: '11 kV Polymeric Type LA',
      img: p11kVPolymericLA,
      overview: 'The 11 kV Polymeric Lightning Arrestor is designed to protect electrical distribution systems from lightning strikes and switching surges. Its polymer housing provides excellent insulation, superior weather resistance, and reliable long-term performance in outdoor applications.',
      features: [],
      applications: [],
    },
    {
      name: '11 kV Porcelain Type LA',
      img: p11kVPorcelainLA,
      overview: 'The 11 kV Porcelain Type Lightning Arrestor is engineered to safeguard electrical equipment against overvoltage caused by lightning and transient surges. Manufactured with high-quality porcelain insulation, it offers dependable protection, mechanical strength, and long service life.',
      features: [],
      applications: [],
    },
    {
      name: '33 kV Polymeric Type LA',
      img: p33kVPolymericLA,
      overview: 'The 33 kV Polymeric Lightning Arrestor is designed for medium-voltage transmission and distribution systems. It provides effective protection against surge voltages while offering excellent moisture resistance, UV stability, and durable performance in demanding environments.',
      features: [],
      applications: [],
    },
  ],
},
 {
  title: 'Control Panel',
  tag: 'Panels',
  type: 'manufacturing',
  items: [
    {
      name: 'Control Panels & Distribution Panel',
      img: pControlPanel,
      overview: 'Control Panels and Distribution Panels are manufactured for efficient control, monitoring, and distribution of electrical power in industrial and commercial installations. They are designed for safe operation, reliable performance, and easy maintenance.',
      features: [],
      applications: [],
    },
    {
      name: 'Distribution Panel (HT & LT)',
      img: pControlPanel2,
      overview: 'HT & LT Distribution Panels are designed to distribute electrical power safely and efficiently across various electrical systems. They offer reliable protection, organized power management, and dependable performance for industrial and utility applications.',
      features: [],
      applications: [],
    },
    {
      name: 'Control Panel (HT & LT)',
      img: pControlPanel3,
      overview: 'HT & LT Control Panels are engineered to control, protect, and monitor electrical equipment in power distribution systems. Built with high-quality components, they ensure safe operation, operational reliability, and long service life.',
      features: [],
      applications: [],
    },
    {
      name: 'Vacuum Circuit Breaker (VCB) Panel',
      img: pControlPanel4,
      overview: 'Vacuum Circuit Breaker (VCB) Panels are designed for medium-voltage switching and protection applications. They provide fast fault interruption, high operational safety, and reliable performance while minimizing maintenance requirements.',
      features: [],
      applications: [],
    },
  ],
},
 {
  title: 'Electrical Conductors',
  tag: 'Conductors',
  type: 'trading',
  items: [
    {
      name: 'ACSR Conductors',
      img: pACSR,
      overview: 'ACSR (Aluminium Conductor Steel Reinforced) Conductors are designed for overhead transmission and distribution lines. They combine lightweight aluminium strands with a steel core to provide high tensile strength, excellent conductivity, and reliable long-span performance.',
      features: [],
      applications: [],
    },
    {
      name: 'AAAC Conductors',
      img: pAAAC,
      overview: 'AAAC (All Aluminium Alloy Conductors) are manufactured for overhead power distribution and transmission networks. They offer excellent corrosion resistance, high strength-to-weight ratio, and superior electrical conductivity for long-term outdoor use.',
      features: [],
      applications: [],
    },
    {
      name: 'AAC Conductors',
      img: pAAC,
      overview: 'AAC (All Aluminium Conductors) are widely used for short-distance overhead distribution lines. Their lightweight construction, high electrical conductivity, and corrosion resistance make them suitable for urban and coastal power networks.',
      features: [],
      applications: [],
    },
    {
      name: 'ACAR Conductors',
      img: pACAR,
      overview: 'ACAR (Aluminium Conductor Alloy Reinforced) Conductors are engineered for overhead transmission and distribution systems. They provide an excellent balance of electrical conductivity, mechanical strength, and reduced line losses for efficient power delivery.',
      features: [],
      applications: [],
    },
    {
      name: 'AL-59 Conductor',
      img: pAL59,
      overview: 'AL-59 Conductors are high-performance aluminium alloy conductors developed for overhead power distribution applications. They offer improved tensile strength, enhanced corrosion resistance, and reliable electrical performance with reduced maintenance requirements.',
      features: [],
      applications: [],
    },
  ],
},
 {
  title: 'Horn Gap & Drop Out Fuses',
  tag: 'Fuses',
  type: 'trading',
  items: [
    {
      name: 'Porcelain Horn Gap Type Fuse Set',
      img: pHornGap,
      overview: 'The Porcelain Horn Gap Type Fuse Set is designed to protect overhead distribution lines from overloads and fault currents. Manufactured with high-quality porcelain insulation, it ensures reliable operation, excellent electrical performance, and long service life.',
      features: [],
      applications: [],
    },
    {
      name: 'Polymer Horn Gap Type Fuse Set',
      img: pDropOut,
      overview: 'The Polymer Horn Gap Type Fuse Set is engineered for dependable protection of medium-voltage distribution systems. Its lightweight polymer housing offers excellent insulation, weather resistance, and reliable performance in outdoor environments.',
      features: [],
      applications: [],
    },
    {
      name: 'Porcelain Drop Out Type Fuse Set',
      img: pDropOut2,
      overview: 'The Porcelain Drop Out Type Fuse Set is used to protect transformers and overhead distribution lines from overcurrent and short-circuit faults. It provides dependable circuit isolation, high mechanical strength, and long-lasting outdoor performance.',
      features: [],
      applications: [],
    },
    {
      name: 'Polymer Drop Out Type Fuse Set',
      img: pDropOut3,
      overview: 'The Polymer Drop Out Type Fuse Set is designed for efficient protection of electrical distribution networks against overloads and fault conditions. It features durable polymer insulation, excellent environmental resistance, and low maintenance operation.',
      features: [],
      applications: [],
    },
  ],
},
  {
  title: 'Insulated Armoured Cables',
  tag: 'Cables',
  type: 'trading',
  items: [
    {
      name: 'XLPE Insulated Armoured Cable',
      img: pXLPE1,
      overview: 'XLPE Insulated Armoured Cables are designed for reliable power transmission in industrial, commercial, and utility applications. They offer excellent electrical insulation, high mechanical protection, and superior resistance to moisture, heat, and environmental conditions.',
      features: [],
      applications: [],
    },
    {
      name: 'XLPE Insulated Armoured Cable (Type 2)',
      img: pXLPE2,
      overview: 'XLPE Insulated Armoured Cable (Type 2) is manufactured for dependable power distribution in demanding environments. Its robust armoured construction ensures enhanced durability, mechanical strength, and long-lasting electrical performance.',
      features: [],
      applications: [],
    },
    {
      name: 'MV XLPE Insulated Armoured Cable',
      img: pMVXLPE,
      overview: 'MV XLPE Insulated Armoured Cables are engineered for medium-voltage power distribution networks. They provide excellent insulation, high current-carrying capacity, and reliable performance under challenging operating conditions.',
      features: [],
      applications: [],
    },
    {
      name: 'PVC Insulated Armoured Cable',
      img: pPVC,
      overview: 'PVC Insulated Armoured Cables are suitable for low-voltage power distribution and industrial wiring applications. They offer dependable electrical performance, effective mechanical protection, and resistance to moisture, abrasion, and corrosion.',
      features: [],
      applications: [],
    },
    {
      name: 'HT Aerial Bunched (HT AB) Cable',
      img: pPht,
      overview: 'HT Aerial Bunched (HT AB) Cables are designed for high-voltage overhead distribution systems. They provide improved safety, reduced power losses, and enhanced reliability while minimizing the risk of electrical faults and unauthorized connections.',
      features: [],
      applications: [],
    },
    {
      name: 'LT Aerial Bunched (LT AB) Cable',
      img: pPlt,
      overview: 'LT Aerial Bunched (LT AB) Cables are widely used in low-voltage overhead distribution networks. They ensure safe and efficient power transmission with excellent insulation, weather resistance, and reduced maintenance requirements.',
      features: [],
      applications: [],
    },
    {
      name: 'Control Cable',
      img: control,
      overview: 'Control cables Send signals to control the functioning of equipment, and transmit electric energy from the distribution points of the power system to the power connection lines of various electric appliances. They typically have a voltage of 300V to 600V and can withstand temperatures up to 900 degrees C',
      features: [],
      applications: [],
    },
    {
      name: 'Power Cable',
      img: power,
      overview: '  Power cables Transport and distribute high-power energy in the main lines of the power system. They typically have a voltage of 0.6/1 kV and above and come in various insulation types and voltage ranges from 1 to 500 kilovolts. Low-voltage power cables are usually in colour',
      features: [],
      applications: [],
    },
  ],
},
  {
  title: 'Cable Boxes (Jointing & Termination Kits)',
  tag: 'Accessories',
  type: 'trading',
  items: [
    {
      name: 'Outdoor Cable Box',
      img: pOutdoorCableBox,
      overview: 'Outdoor Cable Boxes are designed to provide secure cable jointing and termination for outdoor electrical installations. They offer reliable insulation, excellent weather resistance, and durable protection against moisture, dust, and environmental conditions.',
      features: [],
      applications: [],
    },
    {
      name: 'Indoor Cable Box',
      img: pIndoorCableBox,
      overview: 'Indoor Cable Boxes are engineered for safe cable jointing and termination in indoor power distribution systems. They ensure dependable electrical connections, organized cable management, and long-lasting performance with easy installation and maintenance.',
      features: [],
      applications: [],
    },
  ],
}
];

export function slugify(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

export const manufacturingCategories = categories.filter((c) => c.type === 'manufacturing');
export const tradingCategories = categories.filter((c) => c.type === 'trading');

// ---------------------------------------------------------------------------
// FALLBACK ONLY. This category-level text is shown only for products whose
// own `overview` / `features` / `applications` (above, in `categories`) are
// still empty. As soon as you fill a product's own fields, this fallback is
// ignored for that product.
// ---------------------------------------------------------------------------
const categoryDetail = {
  Transformers: {
    overview:
      'Built and tested in-house, this distribution transformer is designed for reliable, efficient power conversion in utility and industrial distribution networks.',
    features: [
      'Wound and assembled in-house with quality-checked copper/aluminium windings',
      'Oil-immersed, naturally cooled design for reliable continuous operation',
      'Tested for ratio, winding resistance, load loss and temperature rise before dispatch',
      'Built to standard distribution voltage classes for easy grid integration',
    ],
    applications: ['Utility distribution networks', 'Industrial & commercial substations', 'Rural electrification projects'],
  },
  'Electrical GI Fabrication': {
    overview:
      'Hot-dip galvanized fabricated structures and hardware engineered for transmission and distribution line construction — built for strength, corrosion resistance and long outdoor service life.',
    features: [
      'Hot-dip galvanized finish for long-term corrosion resistance',
      'Fabricated and welded to standard line-construction specifications',
      'Dimensionally consistent for reliable field assembly',
      'Suitable for both new line construction and maintenance replacement',
    ],
    applications: ['Overhead line support structures', 'Distribution & transmission line hardware', 'Earthing & grounding systems'],
  },
  Wire: {
    overview:
      'Manufactured from high-quality steel and coated with a protective layer of zinc to ensure excellent corrosion resistance, high tensile strength, and long service life.',
    features: [
      'Consistent conductivity and insulation quality',
      'Manufactured / sourced to standard sizing and current ratings',
      'Suitable for both indoor and outdoor wiring applications',
      'Quality-checked before dispatch',
    ],
    applications: ['Residential & commercial wiring', 'Industrial power connections', 'Panel & control wiring'],
  },
  'Pin Insulators': {
    overview:
      'A pin-type insulator engineered to support and insulate overhead line conductors at the pole or cross-arm, keeping the line electrically isolated under all weather conditions.',
    features: [
      'High mechanical and electrical strength for stable line support',
      'Weather and UV resistant construction for long outdoor service life',
      'Consistent creepage distance for reliable insulation performance',
      'Compatible with standard GI pins and cross-arm fittings',
    ],
    applications: ['Overhead distribution lines', 'Rural & urban feeder lines', 'Railway electrification lines'],
  },
  'AB Cable Accessories': {
    overview:
      'A line hardware fitting engineered to secure and connect aerial bunched cable safely along the overhead route.',
    features: [
      'Corrosion-resistant metal construction for long outdoor life',
      'Secure mechanical grip that protects the cable from slippage or damage',
      'Simple, tool-friendly installation on standard AB cable runs',
      'Rated for standard LT/HT aerial bunched cable sizes',
    ],
    applications: ['LT/HT aerial bunched cable networks', 'Overhead service connections', 'Urban & rural distribution lines'],
  },
  'Tower & Pole Support': {
    overview:
      'A structural support member fabricated to specification for carrying overhead conductors and line hardware safely across varied terrain.',
    features: [
      'Fabricated and finished to client specification',
      'Corrosion-resistant coating / galvanisation for long outdoor life',
      'Engineered for consistent load-bearing and wind-load performance',
      'Dispatched with dimensional and weld-quality inspection records',
    ],
    applications: ['Overhead line support structures', 'Distribution & transmission corridors', 'Rural electrification projects'],
  },
  'Disc Insulators': {
    overview:
      'A disc-type insulator used in strings to insulate and support high-tension conductors, offering strong mechanical and electrical performance for demanding line conditions.',
    features: [
      'High mechanical failing load for reliable string performance',
      'Excellent flashover and puncture strength',
      'Weather-sealed design for long outdoor service life',
      'Compatible with standard string hardware and fittings',
    ],
    applications: ['HT transmission & distribution lines', 'Substation gantry structures', 'River-crossing & long-span sections'],
  },
  'Air Break Switches': {
    overview:
      'A manually operated air break switch used to safely isolate a section of the overhead line for maintenance or fault clearing.',
    features: [
      'Positive, visible break for safe manual isolation',
      'Weatherproof construction for reliable outdoor operation',
      'Low operating torque for ease of manual operation',
      'Built to withstand full rated line voltage and current',
    ],
    applications: ['Feeder sectionalising', 'Substation & distribution line isolation', 'Planned maintenance switching'],
  },
  Isolators: {
    overview:
      'An isolator built to provide a clean, visible point of disconnection on the line, ensuring safe working conditions during maintenance.',
    features: [
      'Clear visible-break design for safe isolation',
      'Low-maintenance construction with smooth manual operation',
      'Corrosion-resistant hardware for long outdoor service life',
      'Rated for full line voltage and fault current withstand',
    ],
    applications: ['Substation switching yards', 'Distribution feeder isolation', 'Line maintenance & fault sectionalising'],
  },
  'Lightning Arrestor': {
    overview:
      'A surge arrester designed to protect line and substation equipment from lightning strikes and switching surges by diverting surge current safely to earth.',
    features: [
      'Fast surge response for reliable equipment protection',
      'Stable protection level across the rated voltage range',
      'Weather-sealed housing for long outdoor service life',
      'Low leakage current under normal operating conditions',
    ],
    applications: ['Transformer & substation protection', 'Overhead line surge protection', 'Industrial power equipment protection'],
  },
  'Control Panel': {
    overview:
      'A control and distribution panel built, wired and tested in-house for safe monitoring and switching of electrical loads.',
    features: [
      'Wired and quality-checked in-house before dispatch',
      'Clearly labelled metering, protection and control components',
      'Built to the load and protection scheme specified by the client',
      'Functional, insulation and continuity tested before dispatch',
    ],
    applications: ['Distribution substations', 'Industrial & commercial installations', 'Feeder monitoring & control'],
  },
  'Electrical Conductors': {
    overview:
      'A bare overhead conductor engineered to carry current efficiently across transmission and distribution spans, balancing conductivity, strength and weight.',
    features: [
      'High electrical conductivity for reduced line losses',
      'Engineered strength-to-weight ratio for long spans',
      'Corrosion-resistant strand construction for outdoor durability',
      'Manufactured to standard sizing for easy line design compatibility',
    ],
    applications: ['Overhead transmission lines', 'Distribution feeder lines', 'Rural electrification & line upgrades'],
  },
  'Horn Gap & Drop Out Fuses': {
    overview:
      'A protective fuse set that safely isolates a faulted line section or transformer, giving a clear visible indication of operation.',
    features: [
      'Reliable fault-current interruption with visible drop-out indication',
      'Weatherproof construction for long outdoor service life',
      'Simple, low-maintenance fuse-link replacement',
      'Rated for standard distribution voltage and fault levels',
    ],
    applications: ['Distribution transformer protection', 'Feeder branch protection', 'Overhead line sectional protection'],
  },
  'Insulated Armoured Cables': {
    overview:
      'An insulated, armoured power cable engineered for safe, long-lasting power transmission both underground and above ground.',
    features: [
      'Cross-linked / PVC insulation rated for continuous power transmission',
      'Armoured construction for mechanical protection in tough environments',
      'Suitable for direct burial and duct installation',
      'Manufactured and tested to standard voltage grade specifications',
    ],
    applications: ['Underground power distribution', 'Industrial & commercial power feeders', 'Utility substation interconnections'],
  },
  'Cable Boxes (Jointing & Termination Kits)': {
    overview:
      'A jointing and termination kit engineered to give a safe, sealed, long-lasting connection point for armoured power cables.',
    features: [
      'Sealed construction for weatherproof, fault-free connections',
      'Compatible with standard armoured cable sizes',
      'Straightforward installation for indoor or outdoor use',
      'Built to maintain full-rated insulation at the joint',
    ],
    applications: ['Cable-to-cable jointing', 'Cable-to-switchgear termination', 'Underground to overhead transitions'],
  },
};

function extractVoltage(name) {
  const m = name.match(/(\d+(?:\.\d+)?)\s*kV/i);
  return m ? `${m[1]} kV` : null;
}

function extractMaterial(name) {
  const materials = ['Porcelain', 'Polymer', 'Polymeric', 'Steel', 'Concrete', 'Aluminium', 'XLPE', 'PVC', 'GI'];
  return materials.find((m) => name.toLowerCase().includes(m.toLowerCase())) || null;
}

export function getCategoryBySlug(categorySlug) {
  return categories.find((c) => slugify(c.title) === categorySlug);
}

export function getProduct(categorySlug, index) {
  const category = getCategoryBySlug(categorySlug);
  if (!category) return null;
  const idx = Number(index);
  const item = category.items[idx];
  if (!item) return null;

  const fallback = categoryDetail[category.title] || {
    overview: `A quality-checked ${category.title.toLowerCase()} product, supplied to specification for reliable field performance.`,
    features: ['Manufactured / sourced to specification', 'Quality-checked before dispatch', 'Suitable for standard field installation'],
    applications: ['Power distribution networks', 'Industrial & utility installations'],
  };

  // Use the product's OWN text if it has been filled in; otherwise fall
  // back to the category default. This is the only place that decides
  // which text wins, so editing `categories` above is all that's needed.
  const overview = item.overview && item.overview.trim() ? item.overview : fallback.overview;
  const features = item.features && item.features.length ? item.features : fallback.features;
  const applications = item.applications && item.applications.length ? item.applications : fallback.applications;

  const voltage = extractVoltage(item.name);
  const material = extractMaterial(item.name);

  const specs = [
    { label: 'Category', value: category.title },
    voltage && { label: 'Voltage Rating', value: voltage },
    material && { label: 'Material', value: material },
    { label: 'Availability', value: 'In stock / made to order' },
  ].filter(Boolean);

  return {
    category,
    categorySlug,
    index: idx,
    item,
    overview,
    features,
    applications,
    specs,
    related: category.items.filter((_, i) => i !== idx).slice(0, 4),
  };
}